const forms = {
    "high_level_goal_forms": {
      "personal_credit_optimization": {
        "form_id": "personal_credit_optimization",
        "form_title": "Personal Credit Optimization Assessment",
        "form_description": "Assess your current personal credit situation to create a customized plan for achieving 750+ credit score and maximizing credit limits",
        "input_fields": [
          {
            "field_id": "current_credit_score",
            "field_type": "number",
            "label": "Current Credit Score",
            "placeholder": "Enter your current credit score (300-850)",
            "required": true,
            "validation": {
              "min": 300,
              "max": 850
            }
          },
          {
            "field_id": "credit_score_source",
            "field_type": "select",
            "label": "Credit Score Source",
            "options": [
              "Experian (FICO)",
              "Equifax",
              "TransUnion", 
              "Credit Karma (VantageScore)",
              "Bank Statement",
              "Credit Card App",
              "Other"
            ],
            "required": true
          },
          {
            "field_id": "credit_history_length_months",
            "field_type": "number",
            "label": "Length of Credit History (months)",
            "placeholder": "How many months of credit history do you have?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 600
            }
          },
          {
            "field_id": "current_credit_cards_count",
            "field_type": "number",
            "label": "Number of Current Credit Cards",
            "placeholder": "How many credit cards do you currently have?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 30
            }
          },
          {
            "field_id": "total_credit_limits",
            "field_type": "number",
            "label": "Total Credit Limits ($)",
            "placeholder": "Combined credit limits across all cards",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "total_current_balances",
            "field_type": "number",
            "label": "Total Current Balances ($)",
            "placeholder": "Total debt across all credit cards",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "highest_single_card_limit",
            "field_type": "number",
            "label": "Highest Single Card Limit ($)",
            "placeholder": "Your highest credit limit on any single card",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "current_banking_relationships",
            "field_type": "multiselect",
            "label": "Current Banking Relationships",
            "options": [
              "Chase",
              "American Express", 
              "Bank of America",
              "Wells Fargo",
              "Citi",
              "Capital One",
              "Discover",
              "Goldman Sachs/Apple Card",
              "Local Credit Union",
              "Other"
            ],
            "required": true
          },
          {
            "field_id": "longest_banking_relationship_months",
            "field_type": "number",
            "label": "Longest Banking Relationship (months)",
            "placeholder": "How long have you banked with your primary bank?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 600
            }
          },
          {
            "field_id": "recent_credit_applications",
            "field_type": "number",
            "label": "Credit Applications in Past 24 Months",
            "placeholder": "How many times have you applied for credit?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 50
            }
          },
          {
            "field_id": "late_payments_history",
            "field_type": "select",
            "label": "Late Payment History",
            "options": [
              "No late payments ever",
              "1-2 late payments in past 2 years",
              "3-5 late payments in past 2 years",
              "6+ late payments in past 2 years",
              "Recent late payments (last 6 months)"
            ],
            "required": true
          },
          {
            "field_id": "collections_accounts",
            "field_type": "number",
            "label": "Number of Collection Accounts",
            "placeholder": "How many accounts are currently in collections?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 20
            }
          },
          {
            "field_id": "statement_close_knowledge",
            "field_type": "select",
            "label": "Knowledge of Statement Closing Dates",
            "options": [
              "I know all my statement closing dates",
              "I know some of them",
              "I don't know any of them",
              "What are statement closing dates?"
            ],
            "required": true
          },
          {
            "field_id": "payment_timing_strategy",
            "field_type": "select",
            "label": "Current Payment Timing Strategy",
            "options": [
              "Pay before statement closes (to show 0% utilization)",
              "Pay after statement closes but before due date",
              "Pay on the due date",
              "Sometimes pay late",
              "No specific strategy"
            ],
            "required": true
          },
          {
            "field_id": "authorized_user_status",
            "field_type": "select",
            "label": "Authorized User Status",
            "options": [
              "I'm an authorized user on family member's card",
              "Family members are authorized users on my cards",
              "Not currently using authorized user strategy",
              "Don't understand authorized user strategy"
            ],
            "required": true
          },
          {
            "field_id": "annual_income",
            "field_type": "number",
            "label": "Annual Income ($)",
            "placeholder": "Your total annual income",
            "required": true,
            "validation": {
              "min": 0
            }
          }
        ]
      },
      "business_capital_acquisition": {
        "form_id": "business_capital_acquisition",
        "form_title": "Business Capital Acquisition Assessment",
        "form_description": "Evaluate your business readiness and strategy for accessing $100,000-$200,000 in business credit",
        "input_fields": [
          {
            "field_id": "business_entity_status",
            "field_type": "select",
            "label": "Business Entity Status",
            "options": [
              "No business entity formed yet",
              "LLC formed less than 6 months ago",
              "LLC formed 6-12 months ago",
              "LLC formed 1-2 years ago",
              "LLC formed 2+ years ago",
              "Corporation formed less than 6 months ago",
              "Corporation formed 6-12 months ago",
              "Corporation formed 1-2 years ago",
              "Corporation formed 2+ years ago",
              "Operating as sole proprietorship"
            ],
            "required": true
          },
          {
            "field_id": "business_age_months",
            "field_type": "number",
            "label": "Business Age (months)",
            "placeholder": "How many months has your business been registered/operating?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 600
            }
          },
          {
            "field_id": "ein_and_documentation_status",
            "field_type": "select",
            "label": "EIN and Documentation Status",
            "options": [
              "Have EIN and all required business documents",
              "Have EIN but missing some documents",
              "Don't have EIN yet",
              "Use SSN for business purposes",
              "Not sure what I need"
            ],
            "required": true
          },
          {
            "field_id": "business_banking_setup",
            "field_type": "multiselect",
            "label": "Business Banking Relationships",
            "options": [
              "Chase Business Banking",
              "American Express Business Banking",
              "Bank of America Business Banking",
              "Wells Fargo Business Banking",
              "Citi Business Banking",
              "Local Credit Union Business",
              "No business bank accounts",
              "Other"
            ],
            "required": true
          },
          {
            "field_id": "business_banking_duration_months",
            "field_type": "number",
            "label": "Longest Business Banking Relationship (months)",
            "placeholder": "How long have you had business bank accounts?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 600
            }
          },
          {
            "field_id": "current_business_credit_cards",
            "field_type": "number",
            "label": "Current Business Credit Cards",
            "placeholder": "How many business credit cards do you currently have?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 20
            }
          },
          {
            "field_id": "total_business_credit_limits",
            "field_type": "number",
            "label": "Total Business Credit Limits ($)",
            "placeholder": "Combined limits on all business credit cards",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "monthly_business_revenue",
            "field_type": "number",
            "label": "Monthly Business Revenue ($)",
            "placeholder": "Current average monthly business revenue",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "annual_business_revenue",
            "field_type": "number",
            "label": "Annual Business Revenue ($)",
            "placeholder": "Current or projected annual business revenue",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "business_type_industry",
            "field_type": "select",
            "label": "Business Type/Industry",
            "options": [
              "E-commerce/Online Retail",
              "Consulting Services",
              "Marketing/Advertising Agency",
              "Real Estate Services",
              "Professional Services (Legal, Accounting, etc.)",
              "Construction/Contracting",
              "Retail/Physical Store",
              "Manufacturing",
              "Technology/Software",
              "Healthcare Services",
              "Food Service/Restaurant",
              "Other"
            ],
            "required": true
          },
          {
            "field_id": "business_address_setup",
            "field_type": "select",
            "label": "Business Address Setup",
            "options": [
              "Commercial office/warehouse address",
              "Virtual office address",
              "Home address (separate from personal)",
              "Same as personal address",
              "No official business address"
            ],
            "required": true
          },
          {
            "field_id": "personal_credit_score_for_business",
            "field_type": "number",
            "label": "Personal Credit Score (for business applications)",
            "placeholder": "Your current personal credit score",
            "required": true,
            "validation": {
              "min": 300,
              "max": 850
            }
          },
          {
            "field_id": "business_debt_comfort_level",
            "field_type": "number",
            "label": "Business Debt Comfort Level ($)",
            "placeholder": "Maximum business debt you're comfortable managing",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "zero_percent_apr_experience",
            "field_type": "select",
            "label": "0% APR Business Cards Experience",
            "options": [
              "Successfully used 0% APR business cards",
              "Used them but had challenges",
              "Never used 0% APR business cards",
              "Not familiar with 0% APR strategy"
            ],
            "required": true
          },
          {
            "field_id": "multi_entity_interest",
            "field_type": "select",
            "label": "Interest in Multi-Entity Strategy",
            "options": [
              "Very interested and understand the strategy",
              "Interested but need to learn more",
              "Not sure about multiple entities",
              "Prefer to keep it simple with one entity"
            ],
            "required": true
          }
        ]
      },
      "cash_flow_management": {
        "form_id": "cash_flow_management",
        "form_title": "Cash Flow Management Assessment",
        "form_description": "Analyze your current cash flow situation to optimize payment terms and eliminate interest payments",
        "input_fields": [
          {
            "field_id": "current_monthly_cash_flow",
            "field_type": "number",
            "label": "Current Monthly Cash Flow ($)",
            "placeholder": "Your current monthly cash flow (can be negative)",
            "required": true
          },
          {
            "field_id": "monthly_fixed_expenses",
            "field_type": "number",
            "label": "Monthly Fixed Business Expenses ($)",
            "placeholder": "Total monthly fixed business expenses",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "monthly_variable_expenses",
            "field_type": "number",
            "label": "Monthly Variable Business Expenses ($)",
            "placeholder": "Total monthly variable business expenses",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "supplier_payment_terms",
            "field_type": "multiselect",
            "label": "Current Supplier Payment Terms",
            "options": [
              "Cash on delivery (COD)",
              "Net 15 days",
              "Net 30 days",
              "Net 45 days",
              "Net 60 days",
              "Prepayment required",
              "No regular suppliers",
              "Mixed terms"
            ],
            "required": true
          },
          {
            "field_id": "monthly_supplier_payments",
            "field_type": "number",
            "label": "Monthly Supplier/Vendor Payments ($)",
            "placeholder": "Total monthly payments to suppliers and vendors",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "current_payment_methods",
            "field_type": "multiselect",
            "label": "Current Payment Methods to Suppliers",
            "options": [
              "Cash",
              "Bank transfer/ACH",
              "Business credit cards",
              "Business checks",
              "Personal credit cards",
              "PayPal/digital payments"
            ],
            "required": true
          },
          {
            "field_id": "total_monthly_interest_payments",
            "field_type": "number",
            "label": "Total Monthly Interest Payments ($)",
            "placeholder": "How much do you pay in interest monthly across all debts?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "current_debt_breakdown",
            "field_type": "textarea",
            "label": "Current Debt Breakdown",
            "placeholder": "List your debts with amounts and interest rates (e.g., Business Card A: $10,000 at 18%, Personal Card B: $5,000 at 22%)",
            "required": true
          },
          {
            "field_id": "cash_flow_predictability",
            "field_type": "select",
            "label": "Cash Flow Predictability",
            "options": [
              "Very predictable - steady monthly income",
              "Somewhat predictable - minor fluctuations",
              "Unpredictable - varies significantly",
              "Seasonal - predictable patterns but varies by season",
              "Project-based - depends on contracts/projects"
            ],
            "required": true
          },
          {
            "field_id": "emergency_fund_months",
            "field_type": "number",
            "label": "Emergency Fund Coverage (months)",
            "placeholder": "How many months of expenses does your emergency fund cover?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 24
            }
          },
          {
            "field_id": "banking_bonus_current_income",
            "field_type": "number",
            "label": "Current Monthly Banking Bonus Income ($)",
            "placeholder": "How much do you currently earn from bank account bonuses?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "direct_deposit_flexibility",
            "field_type": "select",
            "label": "Direct Deposit Flexibility",
            "options": [
              "Can split direct deposit across multiple accounts",
              "Can change direct deposit destination monthly",
              "Limited to one direct deposit destination",
              "No direct deposit capability",
              "Self-employed - control all deposits"
            ],
            "required": true
          }
        ]
      },
      "revenue_scaling_without_capital_constraints": {
        "form_id": "revenue_scaling_without_capital_constraints",
        "form_title": "Revenue Scaling Strategy Assessment",
        "form_description": "Evaluate your business growth potential and create a plan for scaling revenue using credit-funded expansion",
        "input_fields": [
          {
            "field_id": "current_monthly_revenue",
            "field_type": "number",
            "label": "Current Monthly Revenue ($)",
            "placeholder": "What is your current average monthly business revenue?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "current_annual_revenue",
            "field_type": "number",
            "label": "Current Annual Revenue ($)",
            "placeholder": "What is your current annual business revenue?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "target_annual_revenue",
            "field_type": "number",
            "label": "Target Annual Revenue ($)",
            "placeholder": "What annual revenue are you targeting?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "revenue_growth_timeline",
            "field_type": "select",
            "label": "Timeline to Reach Revenue Target",
            "options": [
              "6 months",
              "12 months",
              "18 months",
              "24 months",
              "36 months",
              "More than 36 months"
            ],
            "required": true
          },
          {
            "field_id": "current_profit_margin",
            "field_type": "number",
            "label": "Current Profit Margin (%)",
            "placeholder": "What is your current net profit margin percentage?",
            "required": true,
            "validation": {
              "min": -100,
              "max": 100
            }
          },
          {
            "field_id": "historical_growth_rate",
            "field_type": "number",
            "label": "Historical Monthly Growth Rate (%)",
            "placeholder": "What has been your average monthly growth rate?",
            "required": true,
            "validation": {
              "min": -100,
              "max": 1000
            }
          },
          {
            "field_id": "business_model_type",
            "field_type": "select",
            "label": "Primary Business Model",
            "options": [
              "E-commerce/Amazon FBA",
              "Dropshipping",
              "Service-based business",
              "Physical product manufacturing",
              "Digital products/courses",
              "Consulting/coaching",
              "Software/SaaS",
              "Affiliate marketing",
              "Agency services",
              "Other"
            ],
            "required": true
          },
          {
            "field_id": "current_sales_channels",
            "field_type": "multiselect",
            "label": "Current Sales Channels",
            "options": [
              "Amazon",
              "Shopify store",
              "eBay",
              "TikTok Shop",
              "Facebook/Instagram",
              "Own website",
              "Physical store",
              "Direct sales/B2B",
              "Wholesale",
              "Other marketplaces"
            ],
            "required": true
          },
          {
            "field_id": "channel_expansion_interest",
            "field_type": "multiselect",
            "label": "Interested in Expanding to These Channels",
            "options": [
              "Amazon",
              "Shopify",
              "TikTok Shop",
              "Facebook/Instagram Shop",
              "Pinterest",
              "Walmart Marketplace",
              "Etsy",
              "International markets",
              "Wholesale/B2B",
              "Physical retail"
            ],
            "required": true
          },
          {
            "field_id": "scaling_bottlenecks",
            "field_type": "multiselect",
            "label": "Current Scaling Bottlenecks",
            "options": [
              "Lack of capital for inventory",
              "Lack of capital for marketing",
              "Limited team capacity",
              "Technology/systems limitations",
              "Supplier constraints",
              "Market saturation",
              "Competition",
              "Regulatory/compliance issues",
              "Lack of expertise",
              "Time constraints"
            ],
            "required": true
          },
          {
            "field_id": "inventory_investment_needed",
            "field_type": "number",
            "label": "Inventory Investment Needed for Scaling ($)",
            "placeholder": "How much capital do you need for inventory to reach your goals?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "marketing_budget_needed",
            "field_type": "number",
            "label": "Monthly Marketing Budget Needed ($)",
            "placeholder": "What monthly marketing budget would accelerate your growth?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "product_testing_interest",
            "field_type": "select",
            "label": "Interest in New Product/Market Testing",
            "options": [
              "Very interested - want to test aggressively",
              "Interested - want to test carefully",
              "Somewhat interested - occasional testing",
              "Not interested - focus on current products"
            ],
            "required": true
          },
          {
            "field_id": "testing_budget_comfort",
            "field_type": "number",
            "label": "Product Testing Budget Comfort ($)",
            "placeholder": "How much are you comfortable investing per product/market test?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "team_expansion_needs",
            "field_type": "multiselect",
            "label": "Team Expansion Needs",
            "options": [
              "Marketing specialist",
              "Operations manager",
              "Customer service",
              "Virtual assistants",
              "Graphic designer",
              "Content creator",
              "Accountant/bookkeeper",
              "Sales representatives",
              "No additional team needed"
            ],
            "required": true
          }
        ]
      },
      "risk_mitigation": {
        "form_id": "risk_mitigation",
        "form_title": "Risk Mitigation & Asset Protection Assessment",
        "form_description": "Evaluate your current risk exposure and create a plan for protecting personal assets while scaling business operations",
        "input_fields": [
          {
            "field_id": "personal_business_separation",
            "field_type": "select",
            "label": "Current Personal/Business Separation Level",
            "options": [
              "Complete separation - different entities, accounts, everything",
              "Mostly separated - some minor mixing",
              "Partially separated - significant mixing occurs",
              "Minimal separation - mostly mixed together",
              "No separation - everything is mixed"
            ],
            "required": true
          },
          {
            "field_id": "personal_assets_value",
            "field_type": "number",
            "label": "Total Personal Assets Value ($)",
            "placeholder": "Estimated value of your personal assets (home, savings, investments, etc.)",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "personal_savings_amount",
            "field_type": "number",
            "label": "Personal Savings to Preserve ($)",
            "placeholder": "How much personal savings do you want to keep untouched?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "personal_credit_impact_concern",
            "field_type": "select",
            "label": "Concern Level About Personal Credit Impact",
            "options": [
              "Very concerned - must maintain perfect personal credit",
              "Somewhat concerned - want to minimize impact",
              "Neutral - willing to accept some impact",
              "Not concerned - focused on business growth"
            ],
            "required": true
          },
          {
            "field_id": "liability_insurance_coverage",
            "field_type": "multiselect",
            "label": "Current Liability Insurance Coverage",
            "options": [
              "General business liability",
              "Professional liability/E&O",
              "Product liability",
              "Cyber liability",
              "Directors & officers (D&O)",
              "Personal umbrella policy",
              "No liability insurance",
              "Not sure what I have"
            ],
            "required": true
          },
          {
            "field_id": "business_structure_optimization",
            "field_type": "select",
            "label": "Business Structure Optimization Level",
            "options": [
              "Fully optimized with proper legal structure",
              "Mostly optimized but could improve",
              "Basic structure in place",
              "Minimal structure - needs work",
              "No formal structure"
            ],
            "required": true
          },
          {
            "field_id": "funding_source_diversification",
            "field_type": "number",
            "label": "Number of Current Funding Sources",
            "placeholder": "How many different banks/funding sources do you currently have?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 20
            }
          },
          {
            "field_id": "emergency_capital_access",
            "field_type": "number",
            "label": "Emergency Capital Access ($)",
            "placeholder": "How much capital can you access within 48 hours for emergencies?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "recession_preparedness",
            "field_type": "select",
            "label": "Recession/Economic Downturn Preparedness",
            "options": [
              "Very prepared - can survive 24+ months downturn",
              "Well prepared - can survive 12-24 months",
              "Moderately prepared - can survive 6-12 months",
              "Minimally prepared - can survive 3-6 months",
              "Not prepared - vulnerable to short-term disruptions"
            ],
            "required": true
          },
          {
            "field_id": "debt_comfort_level",
            "field_type": "number",
            "label": "Maximum Total Debt Comfort Level ($)",
            "placeholder": "What is the maximum total debt you're comfortable managing?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "legal_compliance_confidence",
            "field_type": "select",
            "label": "Legal Compliance Confidence Level",
            "options": [
              "Very confident - have legal counsel and systems",
              "Confident - understand most requirements",
              "Somewhat confident - basic understanding",
              "Low confidence - need guidance",
              "No confidence - need significant help"
            ],
            "required": true
          }
        ]
      },
      "separate_business_personal_finances": {
        "form_id": "separate_business_personal_finances",
        "form_title": "Business & Personal Finance Separation Assessment",
        "form_description": "Assess your current business and personal finance separation and create a plan for complete entity structuring",
        "input_fields": [
          {
            "field_id": "current_entity_status",
            "field_type": "select",
            "label": "Current Business Entity Status",
            "options": [
              "No business entity formed yet",
              "LLC formed but not properly structured",
              "LLC properly formed and structured",
              "Corporation formed but not optimized",
              "Corporation properly formed and structured",
              "Operating as sole proprietorship"
            ],
            "required": true
          },
          {
            "field_id": "personal_business_separation_level",
            "field_type": "select",
            "label": "Current Personal/Business Separation Level",
            "options": [
              "Complete separation - different entities, accounts, everything",
              "Mostly separated - some minor mixing",
              "Partially separated - significant mixing occurs",
              "Minimal separation - mostly mixed together",
              "No separation - everything is mixed"
            ],
            "required": true
          },
          {
            "field_id": "personal_assets_value",
            "field_type": "number",
            "label": "Total Personal Assets Value ($)",
            "placeholder": "Estimated value of your personal assets (home, savings, investments, etc.)",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "business_bank_accounts",
            "field_type": "multiselect",
            "label": "Current Business Banking Setup",
            "options": [
              "Separate business checking account",
              "Separate business savings account",
              "Business credit cards",
              "Business loans/credit lines",
              "No separate business accounts",
              "Using personal accounts for business"
            ],
            "required": true
          },
          {
            "field_id": "business_documentation_status",
            "field_type": "select",
            "label": "Business Documentation Status",
            "options": [
              "Complete - all required documents filed",
              "Mostly complete - missing some documents",
              "Partially complete - missing important documents",
              "Minimal - basic documents only",
              "No formal documentation"
            ],
            "required": true
          },
          {
            "field_id": "legal_compliance_confidence",
            "field_type": "select",
            "label": "Legal Compliance Confidence Level",
            "options": [
              "Very confident - have legal counsel and systems",
              "Confident - understand most requirements",
              "Somewhat confident - basic understanding",
              "Low confidence - need guidance",
              "No confidence - need significant help"
            ],
            "required": true
          },
          {
            "field_id": "audit_risk_assessment",
            "field_type": "select",
            "label": "Current Audit Risk Level",
            "options": [
              "Very low - fully compliant and documented",
              "Low - mostly compliant",
              "Moderate - some compliance issues",
              "High - significant compliance issues",
              "Very high - major compliance problems"
            ],
            "required": true
          },
          {
            "field_id": "separation_timeline_preference",
            "field_type": "select",
            "label": "Preferred Separation Timeline",
            "options": [
              "Immediate - start right away",
              "Gradual - implement over 2-3 months",
              "Conservative - implement over 4-6 months",
              "Very conservative - implement over 6+ months"
            ],
            "required": true
          }
        ]
      },
      "maintain_clean_personal_credit": {
        "form_id": "maintain_clean_personal_credit",
        "form_title": "Personal Credit Maintenance Assessment",
        "form_description": "Assess your current personal credit situation and create a plan for maintaining 750+ credit score regardless of business debt",
        "input_fields": [
          {
            "field_id": "current_personal_credit_score",
            "field_type": "number",
            "label": "Current Personal Credit Score",
            "placeholder": "Your current personal credit score",
            "required": true,
            "validation": {
              "min": 300,
              "max": 850
            }
          },
          {
            "field_id": "personal_credit_score_source",
            "field_type": "select",
            "label": "Credit Score Source",
            "options": [
              "Experian (FICO)",
              "Equifax",
              "TransUnion", 
              "Credit Karma (VantageScore)",
              "Bank Statement",
              "Credit Card App",
              "Other"
            ],
            "required": true
          },
          {
            "field_id": "personal_credit_cards_count",
            "field_type": "number",
            "label": "Number of Personal Credit Cards",
            "placeholder": "How many personal credit cards do you have?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 30
            }
          },
          {
            "field_id": "personal_total_credit_limits",
            "field_type": "number",
            "label": "Total Personal Credit Limits ($)",
            "placeholder": "Combined credit limits on personal cards only",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "personal_current_utilization",
            "field_type": "number",
            "label": "Current Personal Credit Utilization (%)",
            "placeholder": "What percentage of personal credit limits do you use?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 100
            }
          },
          {
            "field_id": "business_debt_isolation_status",
            "field_type": "select",
            "label": "Business Debt Isolation Status",
            "options": [
              "Complete isolation - no business debt on personal credit",
              "Mostly isolated - minimal business debt on personal",
              "Partially isolated - some business debt on personal",
              "Minimal isolation - significant business debt on personal",
              "No isolation - all business debt on personal credit"
            ],
            "required": true
          },
          {
            "field_id": "personal_credit_impact_from_business",
            "field_type": "select",
            "label": "Personal Credit Impact from Business",
            "options": [
              "No impact - business doesn't affect personal credit",
              "Minimal impact - minor effects on personal credit",
              "Moderate impact - noticeable effects on personal credit",
              "Significant impact - major effects on personal credit",
              "Major impact - business heavily affects personal credit"
            ],
            "required": true
          },
          {
            "field_id": "late_payments_history",
            "field_type": "select",
            "label": "Late Payment History",
            "options": [
              "No late payments ever",
              "1-2 late payments in past 2 years",
              "3-5 late payments in past 2 years",
              "6+ late payments in past 2 years",
              "Recent late payments (last 6 months)"
            ],
            "required": true
          },
          {
            "field_id": "personal_credit_goals",
            "field_type": "select",
            "label": "Personal Credit Score Goals",
            "options": [
              "Maintain current score (750+)",
              "Improve to 750+",
              "Improve to 780+",
              "Improve to 800+",
              "Improve to 850"
            ],
            "required": true
          },
          {
            "field_id": "utilization_optimization_strategy",
            "field_type": "select",
            "label": "Credit Utilization Optimization Strategy",
            "options": [
              "Pay before statement closes (0% utilization)",
              "Pay after statement closes but before due date",
              "Pay on the due date",
              "Sometimes pay late",
              "No specific strategy"
            ],
            "required": true
          }
        ]
      },
      "create_multiple_funding_sources": {
        "form_id": "create_multiple_funding_sources",
        "form_title": "Multiple Funding Sources Assessment",
        "form_description": "Assess your current banking relationships and create a plan for establishing 6-8 major financial institution relationships",
        "input_fields": [
          {
            "field_id": "current_banking_relationships",
            "field_type": "multiselect",
            "label": "Current Banking Relationships",
            "options": [
              "Chase",
              "American Express",
              "Bank of America",
              "Wells Fargo",
              "Citi",
              "Capital One",
              "Discover",
              "Goldman Sachs/Apple Card",
              "Local Credit Union",
              "Online Banks (Ally, Marcus, etc.)",
              "Other"
            ],
            "required": true
          },
          {
            "field_id": "number_of_current_relationships",
            "field_type": "number",
            "label": "Number of Current Banking Relationships",
            "placeholder": "How many different banks/financial institutions do you currently have accounts with?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 20
            }
          },
          {
            "field_id": "total_available_credit_lines",
            "field_type": "number",
            "label": "Total Available Credit Lines ($)",
            "placeholder": "Combined credit limits across all your accounts",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "largest_single_credit_line",
            "field_type": "number",
            "label": "Largest Single Credit Line ($)",
            "placeholder": "Your highest credit limit on any single account",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "current_approval_rate",
            "field_type": "select",
            "label": "Current Credit Application Approval Rate",
            "options": [
              "90-100% - almost always approved",
              "75-89% - usually approved",
              "50-74% - sometimes approved",
              "25-49% - rarely approved",
              "0-24% - almost never approved"
            ],
            "required": true
          },
          {
            "field_id": "relationship_depth_score",
            "field_type": "select",
            "label": "Current Relationship Depth Score",
            "options": [
              "9-10/10 - deep relationships with multiple products",
              "7-8/10 - good relationships with some products",
              "5-6/10 - basic relationships",
              "3-4/10 - minimal relationships",
              "1-2/10 - very basic relationships"
            ],
            "required": true
          },
          {
            "field_id": "target_institutions",
            "field_type": "multiselect",
            "label": "Target Financial Institutions",
            "options": [
              "Chase",
              "American Express",
              "Bank of America",
              "Wells Fargo",
              "Citi",
              "Capital One",
              "Discover",
              "Goldman Sachs/Apple Card",
              "Local Credit Unions",
              "Online Banks",
              "Regional Banks",
              "Other"
            ],
            "required": true
          },
          {
            "field_id": "implementation_timeline",
            "field_type": "select",
            "label": "Implementation Timeline Preference",
            "options": [
              "Aggressive - 6 months to reach 6+ relationships",
              "Moderate - 12 months to reach 6+ relationships",
              "Conservative - 18 months to reach 6+ relationships",
              "Very conservative - 24+ months to reach 6+ relationships"
            ],
            "required": true
          }
        ]
      },
      "establish_emergency_capital_access": {
        "form_id": "establish_emergency_capital_access",
        "form_title": "Emergency Capital Access Assessment",
        "form_description": "Assess your current emergency capital situation and create a plan for establishing $50,000-$100,000 in emergency credit access",
        "input_fields": [
          {
            "field_id": "current_emergency_fund",
            "field_type": "number",
            "label": "Current Emergency Fund ($)",
            "placeholder": "How much cash do you have in emergency savings?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "current_emergency_credit_access",
            "field_type": "number",
            "label": "Current Emergency Credit Access ($)",
            "placeholder": "How much credit can you access within 48 hours?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "current_utilization_rate",
            "field_type": "number",
            "label": "Current Credit Utilization Rate (%)",
            "placeholder": "What percentage of your total credit limits are you using?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 100
            }
          },
          {
            "field_id": "emergency_access_timeline",
            "field_type": "select",
            "label": "Current Emergency Access Timeline",
            "options": [
              "Immediate - within 24 hours",
              "Quick - within 48 hours",
              "Moderate - within 1 week",
              "Slow - within 1 month",
              "Very slow - more than 1 month"
            ],
            "required": true
          },
          {
            "field_id": "cost_of_emergency_capital",
            "field_type": "select",
            "label": "Current Cost of Emergency Capital",
            "options": [
              "0-3% - very low cost",
              "4-7% - low cost",
              "8-12% - moderate cost",
              "13-18% - high cost",
              "19%+ - very high cost"
            ],
            "required": true
          },
          {
            "field_id": "target_emergency_access",
            "field_type": "select",
            "label": "Target Emergency Capital Access",
            "options": [
              "$25,000",
              "$50,000",
              "$75,000",
              "$100,000",
              "$150,000+"
            ],
            "required": true
          },
          {
            "field_id": "emergency_fund_comfort_level",
            "field_type": "select",
            "label": "Emergency Fund Comfort Level",
            "options": [
              "Very comfortable - 6+ months expenses",
              "Comfortable - 3-6 months expenses",
              "Somewhat comfortable - 1-3 months expenses",
              "Uncomfortable - less than 1 month expenses",
              "Very uncomfortable - no emergency fund"
            ],
            "required": true
          },
          {
            "field_id": "implementation_priority",
            "field_type": "select",
            "label": "Implementation Priority",
            "options": [
              "High priority - need immediate access",
              "Medium priority - want to build over time",
              "Low priority - long-term planning",
              "Very low priority - just exploring options"
            ],
            "required": true
          }
        ]
      },
      "build_recession_proof_funding": {
        "form_id": "build_recession_proof_funding",
        "form_title": "Recession-Proof Funding Assessment",
        "form_description": "Assess your current funding stability and create a plan for building recession-proof funding independent of bank lending tightening",
        "input_fields": [
          {
            "field_id": "current_funding_stability",
            "field_type": "select",
            "label": "Current Funding Stability Level",
            "options": [
              "Very stable - 24+ months funding security",
              "Stable - 12-24 months funding security",
              "Moderate - 6-12 months funding security",
              "Unstable - 3-6 months funding security",
              "Very unstable - less than 3 months funding security"
            ],
            "required": true
          },
          {
            "field_id": "credit_line_security_duration",
            "field_type": "select",
            "label": "Current Credit Line Security Duration",
            "options": [
              "24+ months - very secure",
              "12-24 months - secure",
              "6-12 months - moderately secure",
              "3-6 months - less secure",
              "Less than 3 months - insecure"
            ],
            "required": true
          },
          {
            "field_id": "relationship_depth_score",
            "field_type": "select",
            "label": "Current Relationship Depth Score",
            "options": [
              "9-10/10 - deep relationships with multiple products",
              "7-8/10 - good relationships with some products",
              "5-6/10 - basic relationships",
              "3-4/10 - minimal relationships",
              "1-2/10 - very basic relationships"
            ],
            "required": true
          },
          {
            "field_id": "credit_limit_stability",
            "field_type": "select",
            "label": "Credit Limit Stability",
            "options": [
              "95-100% - very stable limits",
              "85-94% - stable limits",
              "70-84% - moderately stable limits",
              "50-69% - less stable limits",
              "Below 50% - unstable limits"
            ],
            "required": true
          },
          {
            "field_id": "alternative_funding_sources",
            "field_type": "multiselect",
            "label": "Current Alternative Funding Sources",
            "options": [
              "Personal savings",
              "Investment accounts",
              "Home equity",
              "Business credit cards",
              "Personal credit cards",
              "Family/friends",
              "Business partners",
              "No alternative sources"
            ],
            "required": true
          },
          {
            "field_id": "economic_downturn_preparation",
            "field_type": "select",
            "label": "Economic Downturn Preparation Level",
            "options": [
              "Very prepared - can survive 24+ months downturn",
              "Well prepared - can survive 12-24 months",
              "Moderately prepared - can survive 6-12 months",
              "Minimally prepared - can survive 3-6 months",
              "Not prepared - vulnerable to short-term disruptions"
            ],
            "required": true
          },
          {
            "field_id": "target_funding_security",
            "field_type": "select",
            "label": "Target Funding Security Duration",
            "options": [
              "12 months",
              "18 months",
              "24 months",
              "36 months",
              "48+ months"
            ],
            "required": true
          },
          {
            "field_id": "implementation_timeline",
            "field_type": "select",
            "label": "Implementation Timeline",
            "options": [
              "6 months",
              "12 months",
              "18 months",
              "24 months",
              "36+ months"
            ],
            "required": true
          }
        ]
      },
      "establish_elite_banking_relationships": {
        "form_id": "establish_elite_banking_relationships",
        "form_title": "Elite Banking Relationships Assessment",
        "form_description": "Assess your current banking relationships and create a plan for establishing elite status with Chase Private Client, AmEx Centurion access, and other premium banking services",
        "input_fields": [
          {
            "field_id": "current_banking_relationships",
            "field_type": "multiselect",
            "label": "Current Banking Relationships",
            "options": [
              "Chase",
              "American Express",
              "Bank of America",
              "Wells Fargo",
              "Citi",
              "Capital One",
              "Discover",
              "Goldman Sachs/Apple Card",
              "Local Credit Union",
              "Online Banks (Ally, Marcus, etc.)",
              "Other"
            ],
            "required": true
          },
          {
            "field_id": "current_deposit_levels",
            "field_type": "number",
            "label": "Current Total Deposits ($)",
            "placeholder": "Total deposits across all bank accounts",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "largest_single_deposit",
            "field_type": "number",
            "label": "Largest Single Bank Deposit ($)",
            "placeholder": "Highest deposit amount in any single bank",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "current_relationship_level",
            "field_type": "select",
            "label": "Current Relationship Level",
            "options": [
              "Basic checking/savings only",
              "Multiple products (credit cards, loans)",
              "Premium checking/savings",
              "Private banking consideration",
              "Private banking qualified",
              "Elite/Concierge services"
            ],
            "required": true
          },
          {
            "field_id": "current_approval_rates",
            "field_type": "select",
            "label": "Current Credit Application Approval Rate",
            "options": [
              "90-100% - almost always approved",
              "75-89% - usually approved",
              "50-74% - sometimes approved",
              "25-49% - rarely approved",
              "0-24% - almost never approved"
            ],
            "required": true
          },
          {
            "field_id": "target_elite_status",
            "field_type": "multiselect",
            "label": "Target Elite Banking Status",
            "options": [
              "Chase Private Client",
              "AmEx Centurion",
              "Bank of America Preferred Rewards",
              "Citi Priority",
              "Wells Fargo Premier",
              "Goldman Sachs Private Wealth",
              "Other private banking services"
            ],
            "required": true
          },
          {
            "field_id": "deposit_growth_capability",
            "field_type": "select",
            "label": "Deposit Growth Capability",
            "options": [
              "Can easily reach $250,000+ deposits",
              "Can reach $250,000+ with effort",
              "Can reach $100,000+ deposits",
              "Can reach $50,000+ deposits",
              "Limited deposit growth capability"
            ],
            "required": true
          },
          {
            "field_id": "relationship_building_timeline",
            "field_type": "select",
            "label": "Relationship Building Timeline",
            "options": [
              "12 months - aggressive timeline",
              "18 months - moderate timeline",
              "24 months - conservative timeline",
              "36 months - very conservative timeline"
            ],
            "required": true
          }
        ]
      },
      "build_business_credit_history": {
        "form_id": "build_business_credit_history",
        "form_title": "Business Credit History Assessment",
        "form_description": "Assess your current business credit situation and create a plan for building excellent business credit history for future traditional lending opportunities",
        "input_fields": [
          {
            "field_id": "business_entity_status",
            "field_type": "select",
            "label": "Business Entity Status",
            "options": [
              "No business entity formed yet",
              "LLC formed less than 6 months ago",
              "LLC formed 6-12 months ago",
              "LLC formed 1-2 years ago",
              "LLC formed 2+ years ago",
              "Corporation formed",
              "Operating as sole proprietorship"
            ],
            "required": true
          },
          {
            "field_id": "current_business_credit_score",
            "field_type": "select",
            "label": "Current Business Credit Score",
            "options": [
              "No business credit score yet",
              "0-20 (poor)",
              "21-40 (fair)",
              "41-60 (good)",
              "61-80 (very good)",
              "81-100 (excellent)"
            ],
            "required": true
          },
          {
            "field_id": "business_credit_bureaus",
            "field_type": "multiselect",
            "label": "Business Credit Bureau Files",
            "options": [
              "Dun & Bradstreet",
              "Experian Business",
              "Equifax Business",
              "FICO SBSS",
              "No business credit files yet"
            ],
            "required": true
          },
          {
            "field_id": "business_payment_history",
            "field_type": "select",
            "label": "Business Payment History",
            "options": [
              "Perfect - 100% on-time payments",
              "Excellent - 95-99% on-time payments",
              "Good - 90-94% on-time payments",
              "Fair - 80-89% on-time payments",
              "Poor - below 80% on-time payments",
              "No business payment history yet"
            ],
            "required": true
          },
          {
            "field_id": "business_credit_cards",
            "field_type": "number",
            "label": "Number of Business Credit Cards",
            "placeholder": "How many business credit cards do you have?",
            "required": true,
            "validation": {
              "min": 0,
              "max": 20
            }
          },
          {
            "field_id": "business_credit_limits",
            "field_type": "number",
            "label": "Total Business Credit Limits ($)",
            "placeholder": "Combined credit limits on business cards",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "business_bank_accounts",
            "field_type": "multiselect",
            "label": "Business Banking Setup",
            "options": [
              "Business checking account",
              "Business savings account",
              "Business credit cards",
              "Business loans/credit lines",
              "No business bank accounts",
              "Using personal accounts for business"
            ],
            "required": true
          },
          {
            "field_id": "target_business_credit_score",
            "field_type": "select",
            "label": "Target Business Credit Score",
            "options": [
              "70+ (good)",
              "80+ (very good)",
              "90+ (excellent)",
              "95+ (outstanding)",
              "100 (perfect)"
            ],
            "required": true
          },
          {
            "field_id": "traditional_lending_goals",
            "field_type": "multiselect",
            "label": "Traditional Lending Goals",
            "options": [
              "SBA loans",
              "Business term loans",
              "Equipment financing",
              "Commercial real estate loans",
              "Business lines of credit",
              "Invoice factoring",
              "Other business financing"
            ],
            "required": true
          },
          {
            "field_id": "implementation_timeline",
            "field_type": "select",
            "label": "Implementation Timeline",
            "options": [
              "6 months - aggressive timeline",
              "12 months - moderate timeline",
              "18 months - conservative timeline",
              "24 months - very conservative timeline"
            ],
            "required": true
          }
        ]
      },
      "create_vendor_supplier_leverage": {
        "form_id": "create_vendor_supplier_leverage",
        "form_title": "Vendor/Supplier Leverage Assessment",
        "form_description": "Assess your current vendor relationships and create a plan for building leverage through reliable payment capability and preferred partner status",
        "input_fields": [
          {
            "field_id": "current_vendor_relationships",
            "field_type": "multiselect",
            "label": "Current Vendor/Supplier Relationships",
            "options": [
              "Inventory suppliers",
              "Service providers",
              "Equipment suppliers",
              "Software/technology vendors",
              "Marketing/advertising vendors",
              "Professional services",
              "No regular vendors yet"
            ],
            "required": true
          },
          {
            "field_id": "current_payment_terms",
            "field_type": "select",
            "label": "Current Payment Terms",
            "options": [
              "Cash on delivery (COD)",
              "Net 15 days",
              "Net 30 days",
              "Net 45 days",
              "Net 60 days",
              "Prepayment required",
              "Mixed terms",
              "No regular payment terms"
            ],
            "required": true
          },
          {
            "field_id": "monthly_vendor_payments",
            "field_type": "number",
            "label": "Monthly Vendor/Supplier Payments ($)",
            "placeholder": "Total monthly payments to vendors and suppliers",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "payment_reliability_score",
            "field_type": "select",
            "label": "Current Payment Reliability Score",
            "options": [
              "100% - always pay on time",
              "95-99% - almost always on time",
              "90-94% - usually on time",
              "80-89% - sometimes late",
              "Below 80% - frequently late",
              "No payment history yet"
            ],
            "required": true
          },
          {
            "field_id": "current_discount_qualification",
            "field_type": "select",
            "label": "Current Discount Qualification",
            "options": [
              "Volume discounts (10%+)",
              "Early payment discounts",
              "Seasonal discounts",
              "No discounts currently",
              "Not sure about discounts"
            ],
            "required": true
          },
          {
            "field_id": "vendor_relationship_strength",
            "field_type": "select",
            "label": "Current Vendor Relationship Strength",
            "options": [
              "Preferred partner status",
              "Valued customer",
              "Regular customer",
              "Occasional customer",
              "New customer",
              "No established relationships"
            ],
            "required": true
          },
          {
            "field_id": "target_payment_terms",
            "field_type": "select",
            "label": "Target Payment Terms",
            "options": [
              "Net 30 days",
              "Net 45 days",
              "Net 60 days",
              "Net 90 days",
              "Flexible terms based on relationship"
            ],
            "required": true
          },
          {
            "field_id": "target_discount_level",
            "field_type": "select",
            "label": "Target Discount Level",
            "options": [
              "10-15% volume discounts",
              "15-20% volume discounts",
              "20-25% volume discounts",
              "25%+ volume discounts",
              "Early payment discounts",
              "Multiple discount types"
            ],
            "required": true
          },
          {
            "field_id": "implementation_timeline",
            "field_type": "select",
            "label": "Implementation Timeline",
            "options": [
              "3 months - aggressive timeline",
              "6 months - moderate timeline",
              "12 months - conservative timeline",
              "18 months - very conservative timeline"
            ],
            "required": true
          }
        ]
      },
      "wealth_building": {
        "form_id": "wealth_building",
        "form_title": "Wealth Building Strategy Assessment",
        "form_description": "Plan your long-term wealth building strategy using business credit and asset acquisition",
        "input_fields": [
          {
            "field_id": "current_net_worth",
            "field_type": "number",
            "label": "Current Net Worth ($)",
            "placeholder": "Your current estimated net worth (assets minus liabilities)",
            "required": true
          },
          {
            "field_id": "target_net_worth",
            "field_type": "number",
            "label": "Target Net Worth ($)",
            "placeholder": "What net worth are you targeting?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "wealth_building_timeline",
            "field_type": "select",
            "label": "Timeline to Reach Wealth Target",
            "options": [
              "2-3 years",
              "3-5 years",
              "5-7 years",
              "7-10 years",
              "10+ years"
            ],
            "required": true
          },
          {
            "field_id": "current_age",
            "field_type": "number",
            "label": "Current Age",
            "placeholder": "Your current age",
            "required": true,
            "validation": {
              "min": 18,
              "max": 100
            }
          },
          {
            "field_id": "w2_income_replacement_goal",
            "field_type": "select",
            "label": "W-2 Income Replacement Goal",
            "options": [
              "Already replaced W-2 income",
              "Want to replace within 12 months",
              "Want to replace within 24 months",
              "Want to replace within 36 months",
              "No W-2 income to replace",
              "Don't want to replace W-2 income"
            ],
            "required": true
          },
          {
            "field_id": "current_w2_income",
            "field_type": "number",
            "label": "Current W-2 Income ($)",
            "placeholder": "Your current W-2 annual income (if applicable)",
            "required": false,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "asset_acquisition_interest",
            "field_type": "multiselect",
            "label": "Asset Acquisition Interests",
            "options": [
              "Real estate rental properties",
              "Commercial real estate",
              "Stock market investments",
              "Business acquisitions",
              "Cryptocurrency",
              "Precious metals",
              "Art/collectibles",
              "Other businesses/franchises",
              "Intellectual property"
            ],
            "required": true
          },
          {
            "field_id": "real_estate_investment_budget",
            "field_type": "number",
            "label": "Real Estate Investment Budget ($)",
            "placeholder": "How much capital can you allocate to real estate investments?",
            "required": true,
            "validation": {
              "min": 0
            }
          },
          {
            "field_id": "passive_income_target",
            "field_type": "number",
            "label": "Monthly Passive Income Target ($)",
            "placeholder": "What monthly passive income are you targeting?",
            "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "current_passive_income",
         "field_type": "number",
         "label": "Current Monthly Passive Income ($)",
         "placeholder": "What is your current monthly passive income?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "investment_experience_level",
         "field_type": "select",
         "label": "Investment Experience Level",
         "options": [
           "Beginner - minimal investment experience",
           "Intermediate - some investment experience",
           "Advanced - significant investment experience",
           "Expert - professional investment background"
         ],
         "required": true
       },
       {
         "field_id": "risk_tolerance_investments",
         "field_type": "select",
         "label": "Investment Risk Tolerance",
         "options": [
           "Conservative - prefer safe, guaranteed returns",
           "Moderate conservative - some risk acceptable",
           "Moderate - balanced risk/reward approach",
           "Moderate aggressive - higher risk for higher returns",
           "Aggressive - maximum risk for maximum returns"
         ],
         "required": true
       },
       {
         "field_id": "business_empire_interest",
         "field_type": "select",
         "label": "Interest in Building Business Empire",
         "options": [
           "Very interested - want multiple businesses",
           "Interested - open to expanding",
           "Somewhat interested - maybe in the future",
           "Not interested - prefer to focus on one business"
         ],
         "required": true
       },
       {
         "field_id": "family_wealth_goals",
         "field_type": "select",
         "label": "Family Wealth/Legacy Goals",
         "options": [
           "Build generational wealth for family",
           "Secure children's education funding",
           "Create family business legacy",
           "Ensure comfortable retirement only",
           "No specific family wealth goals"
         ],
         "required": true
       },
       {
         "field_id": "geographic_diversification_interest",
         "field_type": "select",
         "label": "Geographic Investment Diversification Interest",
         "options": [
           "Very interested - want international investments",
           "Interested - considering international options",
           "Somewhat interested - maybe in the future",
           "Not interested - prefer domestic only"
         ],
         "required": true
       }
     ]
   },
   "strategic_advantages": {
     "form_id": "strategic_advantages",
     "form_title": "Strategic Market Advantages Assessment",
     "form_description": "Analyze your competitive position and develop strategies for market dominance through superior capital access",
     "input_fields": [
       {
         "field_id": "industry_competition_level",
         "field_type": "select",
         "label": "Industry Competition Level",
         "options": [
           "Highly competitive - many established players",
           "Moderately competitive - some competition",
           "Low competition - few players",
           "Emerging market - minimal competition",
           "Monopolistic - little to no competition"
         ],
         "required": true
       },
       {
         "field_id": "competitors_funding_sources",
         "field_type": "multiselect",
         "label": "Competitors' Typical Funding Sources",
         "options": [
           "Traditional bank loans",
           "SBA loans",
           "Venture capital",
           "Angel investors",
           "Personal savings",
           "High-interest credit",
           "Factoring/invoice financing",
           "Revenue-based financing",
           "Don't know"
         ],
         "required": true
       },
       {
         "field_id": "cost_advantage_potential",
         "field_type": "number",
         "label": "Potential Cost Advantage (%)",
         "placeholder": "What percentage cost advantage could 0% financing give you over competitors?",
         "required": true,
         "validation": {
           "min": 0,
           "max": 100
         }
       },
       {
         "field_id": "market_response_speed_importance",
         "field_type": "select",
         "label": "Market Response Speed Importance",
         "options": [
           "Critical - first mover advantage is everything",
           "Very important - speed provides significant advantage",
           "Important - helps but not critical",
           "Somewhat important - nice to have",
           "Not important - speed doesn't matter much"
         ],
         "required": true
       },
       {
         "field_id": "current_market_share",
         "field_type": "number",
         "label": "Current Market Share (%)",
         "placeholder": "What percentage of your target market do you currently capture?",
         "required": true,
         "validation": {
           "min": 0,
           "max": 100
         }
       },
       {
         "field_id": "target_market_share",
         "field_type": "number",
         "label": "Target Market Share (%)",
         "placeholder": "What percentage of the market do you want to capture?",
         "required": true,
         "validation": {
           "min": 0,
           "max": 100
         }
       },
       {
         "field_id": "pricing_strategy_flexibility",
         "field_type": "select",
         "label": "Pricing Strategy Flexibility",
         "options": [
           "High flexibility - can adjust pricing significantly",
           "Moderate flexibility - some pricing options",
           "Low flexibility - limited pricing options",
           "No flexibility - fixed pricing structure"
         ],
         "required": true
       },
       {
         "field_id": "economic_downturn_resilience",
         "field_type": "select",
         "label": "Business Model Recession Resilience",
         "options": [
           "Recession-proof - thrives in downturns",
           "Recession-resistant - survives downturns well",
           "Moderately resilient - some impact but manageable",
           "Vulnerable - significantly impacted by downturns",
           "Highly vulnerable - severe impact from economic stress"
         ],
         "required": true
       },
       {
         "field_id": "supplier_relationship_strength",
         "field_type": "select",
         "label": "Supplier Relationship Strength",
         "options": [
           "Excellent - preferred partner status",
           "Good - reliable relationships",
           "Average - standard business relationships",
           "Poor - frequent issues",
           "No established supplier relationships"
         ],
         "required": true
       },
       {
         "field_id": "customer_loyalty_level",
         "field_type": "select",
         "label": "Customer Loyalty Level",
         "options": [
           "Very high - customers rarely switch",
           "High - most customers are loyal",
           "Moderate - average customer retention",
           "Low - high customer turnover",
           "Very low - customers frequently switch"
         ],
         "required": true
       },
       {
         "field_id": "innovation_capability",
         "field_type": "select",
         "label": "Innovation/Adaptation Capability",
         "options": [
           "Industry leader - first to market with innovations",
           "Fast follower - quick to adopt new trends",
           "Average - keeps up with industry changes",
           "Slow adapter - behind on industry trends",
           "Innovation challenged - struggles with change"
         ],
         "required": true
       },
       {
         "field_id": "international_expansion_interest",
         "field_type": "select",
         "label": "International Market Expansion Interest",
         "options": [
           "Very interested - actively planning expansion",
           "Interested - considering options",
           "Somewhat interested - future possibility",
           "Not interested - domestic focus only"
         ],
         "required": true
       }
     ]
   },
   "create_75_90_day_payment_cycles": {
     "form_id": "create_75_90_day_payment_cycles",
     "form_title": "75-90 Day Payment Cycles Assessment",
     "form_description": "Evaluate your current payment timing strategy and create a plan for implementing 75-90 day payment cycles to optimize cash flow and credit utilization",
     "input_fields": [
       {
         "field_id": "current_payment_timing",
         "field_type": "select",
         "label": "Current Payment Timing Strategy",
         "options": [
           "Pay before statement closes (0% utilization)",
           "Pay after statement closes but before due date",
           "Pay on the due date",
           "Sometimes pay late",
           "No specific strategy",
           "Pay minimum payments only"
         ],
         "required": true
       },
       {
         "field_id": "current_credit_cards_count",
         "field_type": "number",
         "label": "Number of Credit Cards",
         "placeholder": "How many credit cards do you currently have?",
         "required": true,
         "validation": {
           "min": 0,
           "max": 50
         }
       },
       {
         "field_id": "total_credit_limits",
         "field_type": "number",
         "label": "Total Credit Limits ($)",
         "placeholder": "Combined credit limits across all cards",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "current_monthly_spending",
         "field_type": "number",
         "label": "Current Monthly Credit Card Spending ($)",
         "placeholder": "Average monthly spending across all credit cards",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "statement_closing_dates_knowledge",
         "field_type": "select",
         "label": "Knowledge of Statement Closing Dates",
         "options": [
           "I know all my statement closing dates",
           "I know most of them",
           "I know some of them",
           "I don't know any of them",
           "What are statement closing dates?"
         ],
         "required": true
       },
       {
         "field_id": "payment_due_dates_knowledge",
         "field_type": "select",
         "label": "Knowledge of Payment Due Dates",
         "options": [
           "I know all my payment due dates",
           "I know most of them",
           "I know some of them",
           "I don't know any of them",
           "I rely on reminders/notifications"
         ],
         "required": true
       },
       {
         "field_id": "current_utilization_percentage",
         "field_type": "number",
         "label": "Current Average Credit Utilization (%)",
         "placeholder": "What percentage of your total credit limits do you typically use?",
         "required": true,
         "validation": {
           "min": 0,
           "max": 100
         }
       },
       {
         "field_id": "cash_flow_consistency",
         "field_type": "select",
         "label": "Monthly Cash Flow Consistency",
         "options": [
           "Very consistent - same income every month",
           "Mostly consistent - minor fluctuations",
           "Somewhat consistent - moderate variations",
           "Inconsistent - varies significantly",
           "Highly unpredictable - major fluctuations"
         ],
         "required": true
       },
       {
         "field_id": "emergency_fund_months",
         "field_type": "number",
         "label": "Emergency Fund Coverage (months)",
         "placeholder": "How many months of expenses does your emergency fund cover?",
         "required": true,
         "validation": {
           "min": 0,
           "max": 24
         }
       },
       {
         "field_id": "banking_relationships",
         "field_type": "multiselect",
         "label": "Current Banking Relationships",
         "options": [
           "Chase",
           "American Express",
           "Bank of America",
           "Wells Fargo",
           "Citi",
           "Capital One",
           "Discover",
           "Goldman Sachs/Apple Card",
           "Local Credit Union",
           "Online Banks (Ally, Marcus, etc.)",
           "Other"
         ],
         "required": true
       },
       {
         "field_id": "direct_deposit_flexibility",
         "field_type": "select",
         "label": "Direct Deposit Flexibility",
         "options": [
           "Can split direct deposit across multiple accounts",
           "Can change direct deposit destination monthly",
           "Limited to one direct deposit destination",
           "No direct deposit capability",
           "Self-employed - control all deposits"
         ],
         "required": true
       },
       {
         "field_id": "automated_payment_setup",
         "field_type": "select",
         "label": "Current Automated Payment Setup",
         "options": [
           "Fully automated - all payments set up",
           "Partially automated - some payments automated",
           "Manual payments only",
           "Mixed approach - some automated, some manual",
           "No automated payments"
         ],
         "required": true
       },
       {
         "field_id": "late_payment_history",
         "field_type": "select",
         "label": "Late Payment History",
         "options": [
           "No late payments ever",
           "1-2 late payments in past 2 years",
           "3-5 late payments in past 2 years",
           "6+ late payments in past 2 years",
           "Recent late payments (last 6 months)"
         ],
         "required": true
       },
       {
         "field_id": "credit_score_impact_concern",
         "field_type": "select",
         "label": "Credit Score Impact Concern Level",
         "options": [
           "Very concerned - must maintain perfect score",
           "Somewhat concerned - want to minimize impact",
           "Neutral - willing to accept some impact",
           "Not concerned - focused on cash flow optimization"
         ],
         "required": true
       },
       {
         "field_id": "monthly_income",
         "field_type": "number",
         "label": "Monthly Income ($)",
         "placeholder": "Your total monthly income",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "monthly_expenses",
         "field_type": "number",
         "label": "Monthly Expenses ($)",
         "placeholder": "Your total monthly expenses",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "target_payment_cycle_length",
         "field_type": "select",
         "label": "Target Payment Cycle Length",
         "options": [
           "75 days",
           "80 days",
           "85 days",
           "90 days",
           "Flexible - whatever works best"
         ],
         "required": true
       },
       {
         "field_id": "implementation_timeline",
         "field_type": "select",
         "label": "Implementation Timeline Preference",
         "options": [
           "Immediate - start right away",
           "Gradual - implement over 2-3 months",
           "Conservative - implement over 4-6 months",
           "Very conservative - implement over 6+ months"
         ],
         "required": true
       }
     ]
   },
   "extended_payment_terms": {
     "form_id": "extended_payment_terms",
     "form_title": "Extended Payment Terms Assessment",
     "form_description": "Assess your current payment terms strategy and create a plan for implementing extended payment cycles to optimize cash flow and working capital",
     "input_fields": [
       {
         "field_id": "current_payment_timing",
         "field_type": "select",
         "label": "Current Payment Timing Strategy",
         "options": [
           "Pay before statement closes (0% utilization)",
           "Pay after statement closes but before due date",
           "Pay on the due date",
           "Sometimes pay late",
           "No specific strategy",
           "Pay minimum payments only"
         ],
         "required": true
       },
       {
         "field_id": "current_credit_cards_count",
         "field_type": "number",
         "label": "Number of Credit Cards",
         "placeholder": "How many credit cards do you currently have?",
         "required": true,
         "validation": {
           "min": 0,
           "max": 50
         }
       },
       {
         "field_id": "total_credit_limits",
         "field_type": "number",
         "label": "Total Credit Limits ($)",
         "placeholder": "Combined credit limits across all cards",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "current_monthly_spending",
         "field_type": "number",
         "label": "Current Monthly Credit Card Spending ($)",
         "placeholder": "Average monthly spending across all credit cards",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "supplier_payment_terms",
         "field_type": "multiselect",
         "label": "Current Supplier Payment Terms",
         "options": [
           "Cash on delivery (COD)",
           "Net 15 days",
           "Net 30 days",
           "Net 45 days",
           "Net 60 days",
           "Prepayment required",
           "No regular suppliers",
           "Mixed terms"
         ],
         "required": true
       },
       {
         "field_id": "monthly_supplier_payments",
         "field_type": "number",
         "label": "Monthly Supplier/Vendor Payments ($)",
         "placeholder": "Total monthly payments to suppliers and vendors",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "current_payment_methods",
         "field_type": "multiselect",
         "label": "Current Payment Methods to Suppliers",
         "options": [
           "Cash",
           "Bank transfer/ACH",
           "Business credit cards",
           "Business checks",
           "Personal credit cards",
           "PayPal/digital payments"
         ],
         "required": true
       },
       {
         "field_id": "cash_flow_consistency",
         "field_type": "select",
         "label": "Monthly Cash Flow Consistency",
         "options": [
           "Very consistent - same income every month",
           "Mostly consistent - minor fluctuations",
           "Somewhat consistent - moderate variations",
           "Inconsistent - varies significantly",
           "Highly unpredictable - major fluctuations"
         ],
         "required": true
       },
       {
         "field_id": "emergency_fund_months",
         "field_type": "number",
         "label": "Emergency Fund Coverage (months)",
         "placeholder": "How many months of expenses does your emergency fund cover?",
         "required": true,
         "validation": {
           "min": 0,
           "max": 24
         }
       },
       {
         "field_id": "banking_relationships",
         "field_type": "multiselect",
         "label": "Current Banking Relationships",
         "options": [
           "Chase",
           "American Express",
           "Bank of America",
           "Wells Fargo",
           "Citi",
           "Capital One",
           "Discover",
           "Goldman Sachs/Apple Card",
           "Local Credit Union",
           "Online Banks (Ally, Marcus, etc.)",
           "Other"
         ],
         "required": true
       },
       {
         "field_id": "direct_deposit_flexibility",
         "field_type": "select",
         "label": "Direct Deposit Flexibility",
         "options": [
           "Can split direct deposit across multiple accounts",
           "Can change direct deposit destination monthly",
           "Limited to one direct deposit destination",
           "No direct deposit capability",
           "Self-employed - control all deposits"
         ],
         "required": true
       },
       {
         "field_id": "automated_payment_setup",
         "field_type": "select",
         "label": "Current Automated Payment Setup",
         "options": [
           "Fully automated - all payments set up",
           "Partially automated - some payments automated",
           "Manual payments only",
           "Mixed approach - some automated, some manual",
           "No automated payments"
         ],
         "required": true
       },
       {
         "field_id": "late_payment_history",
         "field_type": "select",
         "label": "Late Payment History",
         "options": [
           "No late payments ever",
           "1-2 late payments in past 2 years",
           "3-5 late payments in past 2 years",
           "6+ late payments in past 2 years",
           "Recent late payments (last 6 months)"
         ],
         "required": true
       },
       {
         "field_id": "credit_score_impact_concern",
         "field_type": "select",
         "label": "Credit Score Impact Concern Level",
         "options": [
           "Very concerned - must maintain perfect score",
           "Somewhat concerned - want to minimize impact",
           "Neutral - willing to accept some impact",
           "Not concerned - focused on cash flow optimization"
         ],
         "required": true
       },
       {
         "field_id": "monthly_income",
         "field_type": "number",
         "label": "Monthly Income ($)",
         "placeholder": "Your total monthly income",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "monthly_expenses",
         "field_type": "number",
         "label": "Monthly Expenses ($)",
         "placeholder": "Your total monthly expenses",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "target_payment_cycle_length",
         "field_type": "select",
         "label": "Target Payment Cycle Length",
         "options": [
           "75 days",
           "80 days",
           "85 days",
           "90 days",
           "Flexible - whatever works best"
         ],
         "required": true
       },
       {
         "field_id": "implementation_timeline",
         "field_type": "select",
         "label": "Implementation Timeline Preference",
         "options": [
           "Immediate - start right away",
           "Gradual - implement over 2-3 months",
           "Conservative - implement over 4-6 months",
           "Very conservative - implement over 6+ months"
         ],
         "required": true
       }
     ]
   },
   "eliminate_interest_payments": {
     "form_id": "eliminate_interest_payments",
     "form_title": "Eliminate Interest Payments Assessment",
     "form_description": "Assess your current debt situation and create a plan for eliminating interest payments through strategic credit rotation",
     "input_fields": [
       {
         "field_id": "current_total_debt",
         "field_type": "number",
         "label": "Current Total Debt ($)",
         "placeholder": "Total amount of debt across all accounts",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "current_monthly_interest_payments",
         "field_type": "number",
         "label": "Current Monthly Interest Payments ($)",
         "placeholder": "How much do you pay in interest monthly?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "current_debt_breakdown",
         "field_type": "textarea",
         "label": "Current Debt Breakdown",
         "placeholder": "List your debts with amounts and interest rates (e.g., Business Card A: $10,000 at 18%, Personal Card B: $5,000 at 22%)",
         "required": true
       },
       {
         "field_id": "current_credit_cards_count",
         "field_type": "number",
         "label": "Number of Credit Cards",
         "placeholder": "How many credit cards do you currently have?",
         "required": true,
         "validation": {
           "min": 0,
           "max": 50
         }
       },
       {
         "field_id": "total_credit_limits",
         "field_type": "number",
         "label": "Total Credit Limits ($)",
         "placeholder": "Combined credit limits across all cards",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "current_utilization_percentage",
         "field_type": "number",
         "label": "Current Average Credit Utilization (%)",
         "placeholder": "What percentage of your total credit limits do you typically use?",
         "required": true,
         "validation": {
           "min": 0,
           "max": 100
         }
       },
       {
         "field_id": "zero_percent_apr_experience",
         "field_type": "select",
         "label": "0% APR Cards Experience",
         "options": [
           "Successfully used 0% APR cards",
           "Used them but had challenges",
           "Never used 0% APR cards",
           "Not familiar with 0% APR strategy"
         ],
         "required": true
       },
       {
         "field_id": "balance_transfer_experience",
         "field_type": "select",
         "label": "Balance Transfer Experience",
         "options": [
           "Successfully completed balance transfers",
           "Attempted but had issues",
           "Never done balance transfers",
           "Not familiar with balance transfers"
         ],
         "required": true
       },
       {
         "field_id": "credit_score",
         "field_type": "number",
         "label": "Current Credit Score",
         "placeholder": "Your current credit score",
         "required": true,
         "validation": {
           "min": 300,
           "max": 850
         }
       },
       {
         "field_id": "monthly_income",
         "field_type": "number",
         "label": "Monthly Income ($)",
         "placeholder": "Your total monthly income",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "monthly_expenses",
         "field_type": "number",
         "label": "Monthly Expenses ($)",
         "placeholder": "Your total monthly expenses",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "debt_elimination_timeline",
         "field_type": "select",
         "label": "Preferred Debt Elimination Timeline",
         "options": [
           "6 months or less",
           "6-12 months",
           "12-18 months",
           "18-24 months",
           "More than 24 months"
         ],
         "required": true
       },
       {
         "field_id": "risk_tolerance",
         "field_type": "select",
         "label": "Risk Tolerance for Credit Strategy",
         "options": [
           "Conservative - prefer safe, guaranteed approaches",
           "Moderate - willing to take calculated risks",
           "Aggressive - willing to use advanced strategies",
           "Very aggressive - want maximum results quickly"
         ],
         "required": true
       }
     ]
   },
   "generate_banking_bonuses": {
     "form_id": "generate_banking_bonuses",
     "form_title": "Banking Bonuses Assessment",
     "form_description": "Assess your current banking relationships and create a plan for generating $300-600 monthly banking bonuses",
     "input_fields": [
       {
         "field_id": "current_banking_relationships",
         "field_type": "multiselect",
         "label": "Current Banking Relationships",
         "options": [
           "Chase",
           "American Express",
           "Bank of America",
           "Wells Fargo",
           "Citi",
           "Capital One",
           "Discover",
           "Goldman Sachs/Apple Card",
           "Local Credit Union",
           "Online Banks (Ally, Marcus, etc.)",
           "Other"
         ],
         "required": true
       },
       {
         "field_id": "current_monthly_bonus_income",
         "field_type": "number",
         "label": "Current Monthly Banking Bonus Income ($)",
         "placeholder": "How much do you currently earn from bank account bonuses?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "direct_deposit_flexibility",
         "field_type": "select",
         "label": "Direct Deposit Flexibility",
         "options": [
           "Can split direct deposit across multiple accounts",
           "Can change direct deposit destination monthly",
           "Limited to one direct deposit destination",
           "No direct deposit capability",
           "Self-employed - control all deposits"
         ],
         "required": true
       },
       {
         "field_id": "monthly_income",
         "field_type": "number",
         "label": "Monthly Income ($)",
         "placeholder": "Your total monthly income",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "banking_bonus_experience",
         "field_type": "select",
         "label": "Banking Bonus Experience",
         "options": [
           "Currently earning bonuses from multiple banks",
           "Have earned bonuses in the past",
           "Never earned banking bonuses",
           "Not familiar with banking bonuses"
         ],
         "required": true
       },
       {
         "field_id": "account_maintenance_comfort",
         "field_type": "select",
         "label": "Account Maintenance Comfort Level",
         "options": [
           "Very comfortable managing multiple accounts",
           "Somewhat comfortable with account management",
           "Prefer minimal account management",
           "Not comfortable with complex banking"
         ],
         "required": true
       },
       {
         "field_id": "target_monthly_bonus",
         "field_type": "select",
         "label": "Target Monthly Bonus Income",
         "options": [
           "$200-300",
           "$300-400",
           "$400-500",
           "$500-600",
           "$600+"
         ],
         "required": true
       },
       {
         "field_id": "implementation_timeline",
         "field_type": "select",
         "label": "Implementation Timeline",
         "options": [
           "Immediate - start right away",
           "Gradual - implement over 2-3 months",
           "Conservative - implement over 4-6 months",
           "Very conservative - implement over 6+ months"
         ],
         "required": true
       }
     ]
   },
   "working_capital_efficiency": {
     "form_id": "working_capital_efficiency",
     "form_title": "Working Capital Efficiency Assessment",
     "form_description": "Assess your current working capital situation and create a plan for optimizing cash flow and operational efficiency",
     "input_fields": [
       {
         "field_id": "current_monthly_revenue",
         "field_type": "number",
         "label": "Current Monthly Revenue ($)",
         "placeholder": "What is your current average monthly business revenue?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "current_annual_revenue",
         "field_type": "number",
         "label": "Current Annual Revenue ($)",
         "placeholder": "What is your current annual business revenue?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "monthly_fixed_expenses",
         "field_type": "number",
         "label": "Monthly Fixed Business Expenses ($)",
         "placeholder": "Total monthly fixed business expenses",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "monthly_variable_expenses",
         "field_type": "number",
         "label": "Monthly Variable Business Expenses ($)",
         "placeholder": "Total monthly variable business expenses",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "current_profit_margin",
         "field_type": "number",
         "label": "Current Profit Margin (%)",
         "placeholder": "What is your current net profit margin percentage?",
         "required": true,
         "validation": {
           "min": -100,
           "max": 100
         }
       },
       {
         "field_id": "inventory_investment_needed",
         "field_type": "number",
         "label": "Inventory Investment Needed for Scaling ($)",
         "placeholder": "How much capital do you need for inventory to reach your goals?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "marketing_budget_needed",
         "field_type": "number",
         "label": "Monthly Marketing Budget Needed ($)",
         "placeholder": "What monthly marketing budget would accelerate your growth?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "business_model_type",
         "field_type": "select",
         "label": "Primary Business Model",
         "options": [
           "E-commerce/Amazon FBA",
           "Dropshipping",
           "Service-based business",
           "Physical product manufacturing",
           "Digital products/courses",
           "Consulting/coaching",
           "Software/SaaS",
           "Affiliate marketing",
           "Agency services",
           "Other"
         ],
         "required": true
       },
       {
         "field_id": "current_sales_channels",
         "field_type": "multiselect",
         "label": "Current Sales Channels",
         "options": [
           "Amazon",
           "Shopify store",
           "eBay",
           "TikTok Shop",
           "Facebook/Instagram",
           "Own website",
           "Physical store",
           "Direct sales/B2B",
           "Wholesale",
           "Other marketplaces"
         ],
         "required": true
       },
       {
         "field_id": "scaling_bottlenecks",
         "field_type": "multiselect",
         "label": "Current Scaling Bottlenecks",
         "options": [
           "Lack of capital for inventory",
           "Lack of capital for marketing",
           "Limited team capacity",
           "Technology/systems limitations",
           "Supplier constraints",
           "Market saturation",
           "Competition",
           "Regulatory/compliance issues",
           "Lack of expertise",
           "Time constraints"
         ],
         "required": true
       },
       {
         "field_id": "cash_flow_predictability",
         "field_type": "select",
         "label": "Cash Flow Predictability",
         "options": [
           "Very predictable - steady monthly income",
           "Somewhat predictable - minor fluctuations",
           "Unpredictable - varies significantly",
           "Seasonal - predictable patterns but varies by season",
           "Project-based - depends on contracts/projects"
         ],
         "required": true
       },
       {
         "field_id": "emergency_fund_months",
         "field_type": "number",
         "label": "Emergency Fund Coverage (months)",
         "placeholder": "How many months of expenses does your emergency fund cover?",
         "required": true,
         "validation": {
           "min": 0,
           "max": 24
         }
       },
       {
         "field_id": "business_debt_comfort_level",
         "field_type": "number",
         "label": "Business Debt Comfort Level ($)",
         "placeholder": "Maximum business debt you're comfortable managing",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "revenue_growth_timeline",
         "field_type": "select",
         "label": "Timeline to Reach Revenue Target",
         "options": [
           "6 months",
           "12 months",
           "18 months",
           "24 months",
           "36 months",
           "More than 36 months"
         ],
         "required": true
       },
       {
         "field_id": "team_expansion_needs",
         "field_type": "multiselect",
         "label": "Team Expansion Needs",
         "options": [
           "Marketing specialist",
           "Operations manager",
           "Customer service",
           "Virtual assistants",
           "Graphic designer",
           "Content creator",
           "Accountant/bookkeeper",
           "Sales representatives",
           "No additional team needed"
         ],
         "required": true
       }
     ]
   },
   "fund_initial_inventory_operations": {
     "form_id": "fund_initial_inventory_operations",
     "form_title": "Fund Initial Inventory/Operations Assessment",
     "form_description": "Assess your current business startup needs and create a plan for funding initial inventory and operations without personal financial risk",
     "input_fields": [
       {
         "field_id": "business_stage",
         "field_type": "select",
         "label": "Current Business Stage",
         "options": [
           "Planning/Research phase",
           "Ready to launch",
           "Recently launched (less than 6 months)",
           "Established business (6+ months)",
           "Looking to expand"
         ],
         "required": true
       },
       {
         "field_id": "initial_capital_needed",
         "field_type": "number",
         "label": "Initial Capital Needed ($)",
         "placeholder": "How much capital do you need to start/expand?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "personal_savings_available",
         "field_type": "number",
         "label": "Personal Savings Available ($)",
         "placeholder": "How much personal savings can you contribute?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "business_type",
         "field_type": "select",
         "label": "Business Type",
         "options": [
           "E-commerce/Online Retail",
           "Physical Retail Store",
           "Service Business",
           "Manufacturing",
           "Consulting/Coaching",
           "Digital Products",
           "Food Service",
           "Other"
         ],
         "required": true
       },
       {
         "field_id": "inventory_needs",
         "field_type": "multiselect",
         "label": "Initial Inventory/Equipment Needs",
         "options": [
           "Physical inventory/products",
           "Equipment/machinery",
           "Technology/software",
           "Office supplies/furniture",
           "Marketing materials",
           "Licenses/permits",
           "Insurance",
           "Other startup costs"
         ],
         "required": true
       },
       {
         "field_id": "credit_score",
         "field_type": "number",
         "label": "Current Credit Score",
         "placeholder": "Your current credit score",
         "required": true,
         "validation": {
           "min": 300,
           "max": 850
         }
       },
       {
         "field_id": "business_entity_status",
         "field_type": "select",
         "label": "Business Entity Status",
         "options": [
           "No business entity formed yet",
           "LLC formed less than 6 months ago",
           "LLC formed 6-12 months ago",
           "LLC formed 1-2 years ago",
           "LLC formed 2+ years ago",
           "Corporation formed",
           "Operating as sole proprietorship"
         ],
         "required": true
       },
       {
         "field_id": "monthly_income",
         "field_type": "number",
         "label": "Monthly Income ($)",
         "placeholder": "Your total monthly income",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "timeline_to_profitability",
         "field_type": "select",
         "label": "Expected Timeline to Profitability",
         "options": [
           "1-3 months",
           "3-6 months",
           "6-12 months",
           "12-18 months",
           "More than 18 months"
         ],
         "required": true
       },
       {
         "field_id": "risk_tolerance",
         "field_type": "select",
         "label": "Risk Tolerance for Funding",
         "options": [
           "Very conservative - want to preserve all personal savings",
           "Conservative - willing to use some personal funds",
           "Moderate - balanced approach",
           "Aggressive - willing to use credit strategically"
         ],
         "required": true
       }
     ]
   },
   "scale_business_operations": {
     "form_id": "scale_business_operations",
     "form_title": "Scale Business Operations Assessment",
     "form_description": "Assess your current business growth potential and create a plan for scaling operations using credit-funded expansion",
     "input_fields": [
       {
         "field_id": "current_monthly_revenue",
         "field_type": "number",
         "label": "Current Monthly Revenue ($)",
         "placeholder": "What is your current average monthly business revenue?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "current_annual_revenue",
         "field_type": "number",
         "label": "Current Annual Revenue ($)",
         "placeholder": "What is your current annual business revenue?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "target_annual_revenue",
         "field_type": "number",
         "label": "Target Annual Revenue ($)",
         "placeholder": "What annual revenue are you targeting?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "revenue_growth_timeline",
         "field_type": "select",
         "label": "Timeline to Reach Revenue Target",
         "options": [
           "6 months",
           "12 months",
           "18 months",
           "24 months",
           "36 months",
           "More than 36 months"
         ],
         "required": true
       },
       {
         "field_id": "current_profit_margin",
         "field_type": "number",
         "label": "Current Profit Margin (%)",
         "placeholder": "What is your current net profit margin percentage?",
         "required": true,
         "validation": {
           "min": -100,
           "max": 100
         }
       },
       {
         "field_id": "historical_growth_rate",
         "field_type": "number",
         "label": "Historical Monthly Growth Rate (%)",
         "placeholder": "What has been your average monthly growth rate?",
         "required": true,
         "validation": {
           "min": -100,
           "max": 1000
         }
       },
       {
         "field_id": "business_model_type",
         "field_type": "select",
         "label": "Primary Business Model",
         "options": [
           "E-commerce/Amazon FBA",
           "Dropshipping",
           "Service-based business",
           "Physical product manufacturing",
           "Digital products/courses",
           "Consulting/coaching",
           "Software/SaaS",
           "Affiliate marketing",
           "Agency services",
           "Other"
         ],
         "required": true
       },
       {
         "field_id": "scaling_bottlenecks",
         "field_type": "multiselect",
         "label": "Current Scaling Bottlenecks",
         "options": [
           "Lack of capital for inventory",
           "Lack of capital for marketing",
           "Limited team capacity",
           "Technology/systems limitations",
           "Supplier constraints",
           "Market saturation",
           "Competition",
           "Regulatory/compliance issues",
           "Lack of expertise",
           "Time constraints"
         ],
         "required": true
       },
       {
         "field_id": "inventory_investment_needed",
         "field_type": "number",
         "label": "Inventory Investment Needed for Scaling ($)",
         "placeholder": "How much capital do you need for inventory to reach your goals?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "marketing_budget_needed",
         "field_type": "number",
         "label": "Monthly Marketing Budget Needed ($)",
         "placeholder": "What monthly marketing budget would accelerate your growth?",
         "required": true,
         "validation": {
           "min": 0
         }
       },
       {
         "field_id": "team_expansion_needs",
         "field_type": "multiselect",
         "label": "Team Expansion Needs",
         "options": [
           "Marketing specialist",
           "Operations manager",
           "Customer service",
           "Virtual assistants",
           "Graphic designer",
           "Content creator",
           "Accountant/bookkeeper",
           "Sales representatives",
           "No additional team needed"
         ],
         "required": true
       },
       {
         "field_id": "credit_score",
         "field_type": "number",
         "label": "Current Credit Score",
         "placeholder": "Your current credit score",
         "required": true,
         "validation": {
           "min": 300,
           "max": 850
         }
       },
       {
         "field_id": "business_entity_status",
         "field_type": "select",
         "label": "Business Entity Status",
         "options": [
           "No business entity formed yet",
           "LLC formed less than 6 months ago",
           "LLC formed 6-12 months ago",
           "LLC formed 1-2 years ago",
           "LLC formed 2+ years ago",
           "Corporation formed",
           "Operating as sole proprietorship"
         ],
         "required": true
       }
     ]
   }
 }
}

export default forms;